import React from 'react';

const QuoteMark = ({ className = '' }) => (
  <>
    <style>{`
      .vwp-quote-mark {
        margin-right: 16px;
        display: inline-block;
        vertical-align: middle;
        position: relative;
        top: -30px;
        width: 36px;
        height: 28px;
      }
    `}</style>
    <span className={`vwp-quote-mark${className ? ' ' + className : ''}`} aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="28" viewBox="0 0 36 28" fill="none">
        <path d="M0.810547 27.24L8.09055 0.199951H17.4505L13.2905 27.24H0.810547ZM18.4905 27.24L25.7705 0.199951H35.1306L30.9705 27.24H18.4905Z" fill="#473BF0"/>
        <path d="M0.810547 27.24L8.09055 0.199951H17.4505L13.2905 27.24H0.810547ZM18.4905 27.24L25.7705 0.199951H35.1306L30.9705 27.24H18.4905Z" fill="url(#paint0_linear_10613_5588)"/>
        <defs>
          <linearGradient id="paint0_linear_10613_5588" x1="21.8541" y1="131.871" x2="-54.8475" y2="97.6155" gradientUnits="userSpaceOnUse">
            <stop stopColor="#F5B462"/>
            <stop offset="1" stopColor="#FE9E26"/>
          </linearGradient>
        </defs>
      </svg>
    </span>
  </>
);

export default QuoteMark; 